var map = {
	"./add.svg": "876b",
	"./advertiser.svg": "03d9",
	"./advertisers.svg": "253a",
	"./arrow.svg": "5975",
	"./birthday-cake.png": "326e",
	"./birthday-cake.svg": "1725",
	"./calendar.svg": "6bca",
	"./child-companies.svg": "bd1e",
	"./clock.svg": "0fbd",
	"./code-bar.svg": "a2eb",
	"./communication.jpg": "f182",
	"./controls.svg": "6e24",
	"./controls_color.svg": "d11c",
	"./customers.svg": "9a85",
	"./donate.svg": "d60c",
	"./email_template.svg": "17e0",
	"./fidelity.svg": "5d1c",
	"./herited.svg": "6172",
	"./invoice.svg": "cfff",
	"./key.svg": "1fb0",
	"./logout.svg": "c5d0",
	"./loyalty.png": "60cc",
	"./loyalty_core.svg": "b44a",
	"./manage.svg": "4b24",
	"./offer.svg": "ca3d",
	"./percentage-blue.svg": "a57d",
	"./percentage.svg": "51fb",
	"./piggy-bank.svg": "a17b",
	"./points-of-sale.svg": "43ab",
	"./procustomers.svg": "a0d1",
	"./publisher.svg": "37d6",
	"./publishing.svg": "e205",
	"./ratecards.svg": "e207",
	"./reward-input.png": "5dd5",
	"./shopping-cart.svg": "3ab1",
	"./store.svg": "2033",
	"./trade.svg": "4dd0",
	"./transactions.svg": "9762",
	"./voucher.svg": "670d",
	"./waiter.svg": "2b70",
	"./wallet-pass.png": "7b2e",
	"./welcome.png": "d4d6",
	"./welcome.svg": "b7e8"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "0075";